module.exports = __webpack_public_path__ + "img/courseMeta.87f7242a.svg";